/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import { editMode } from "helpers/Utils.js";
import StudentEdit2 from "components/Student/Student2.component.edit.jsx";
import * as dateFns from "date-fns";

class ConsecutiveAbsences extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      students: [],
      openStudentModal: false,
      studentId: "",
    };
  }

  onCloseModal = () => {
    this.resetModal();
  };

  resetModal = () => {
    return new Promise((resolve, reject) => {
      this.setState(
        {
          students: [],
          openStudentModal: false,
          studentId: "",
        },
        resolve(true)
      );
    });
  };

  toggleStudentModal = () => {
    return new Promise((resolve, reject) => {
      let mainState = this.state;
      mainState.openStudentModal = !mainState.openStudentModal;
      this.setState(mainState, resolve(true));
    });
  };

  openStudentEditModal = (id) => {
    this.toggleStudentModal();
    return new Promise((resolve, reject) => {
      let mainState = this.state;
      mainState.studentId = id;
      this.setState(mainState, resolve(true));
    });
  };

  refresh() {
    return new Promise((resolve, reject) => {
      axios.get("dashboard/ConsecutiveAbsences").then((response) => {
        let modalState = this.state;

        modalState.students = [];
        response.data.data.map((student, index) =>
          modalState.students.push({
            id: student.id,
            name: student.name,
            date: dateFns.format(dateFns.parseISO(student.date), "MM/dd/yyyy"),
          })
        );

        this.setState({ modalState }, resolve(true));
      });
    });
  }

  onOpened() {
    this.refresh();
  }

  render() {
    let students = this.state.students.map((student) => {
      return (
        <tr key={student.id}>
          <td>
            <a
              onClick={this.openStudentEditModal.bind(this, student.id)}
              href="#"
            >
              {student.name}
            </a>
          </td>
          <td>{student.date}</td>
        </tr>
      );
    });

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.toggle.bind(this)}
                centered={true}
                autoFocus={true}
                size={"lg"}
                backdrop="static"
                unmountOnClose={true}
                onOpened={this.onOpened.bind(this)}
                onClosed={this.onCloseModal}
                scrollable
              >
                <ModalHeader toggle={this.props.toggle.bind(this)}>
                  5 Consecutive Absences
                </ModalHeader>
                <ModalBody>
                  <Table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Last Absence</th>
                      </tr>
                    </thead>

                    <tbody>{students}</tbody>
                  </Table>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="primary"
                    onClick={this.props.toggle.bind(this)}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            </Col>
            <StudentEdit2
              isOpen={this.state.openStudentModal}
              toggleStudentModal={this.toggleStudentModal.bind(this)}
              editMode={editMode.EDIT}
              id={this.state.studentId}
              tables={this.props.tables}
            />
          </Row>
        </div>
      </>
    );
  }
}

export default ConsecutiveAbsences;
